import React from "react";
import { Link } from "react-router-dom";
import { Play, Video } from "lucide-react";

import "./HomeHero.css";

const FEATURED_CREATOR = "katchrugby";
const CREATOR_VIDEOS_URL = `/${FEATURED_CREATOR}`;

const HomeHero = () => {
  return (
    <header className="home-hero">
      <div className="home-hero__content">
        <span className="home-hero__eyebrow">DISCOVER KATCH</span>

        <h1 className="home-hero__title">
          Stream Share <span>Connect</span>
        </h1>

        <p className="home-hero__description">
          Stream videos, share moments and connect with your community.
        </p>

        <div className="home-hero__actions">
          <Link
            to="/pops"
            className="home-hero__button home-hero__button--primary"
          >
            <Play size={17} fill="currentColor" aria-hidden="true" />
            <span>Explore Pops</span>
          </Link>

          <Link
            to={CREATOR_VIDEOS_URL}
            className="home-hero__button home-hero__button--secondary"
          >
            <Video size={18} aria-hidden="true" />
            <span>Watch Videos</span>
          </Link>
        </div>
      </div>

      <div className="home-hero__art" aria-hidden="true">
        <div className="home-hero__art-circle">
          <Play size={44} strokeWidth={1.4} />
        </div>

        <div className="home-hero__art-caption">WATCH. DISCOVER. REPLAY.</div>
      </div>
    </header>
  );
};

export default HomeHero;
